module.exports = ".modal-open .modal {\n  overflow-y: hidden;\n}\n\n.modal-body-scroll-auto {\n  overflow-y: visible;\n  -webkit-transition: height 0.5s ease;\n  transition: height 0.5s ease;\n}\n\n.overlay {\n  width: 100vw;\n  height: 100vh;\n  position: absolute;\n}\n\n.modal-dialog.modal-dialog-centered {\n  position: absolute;\n  right: 0;\n  left: 0;\n  top: 0;\n  bottom: 0;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/choosepayment-modal/choosepayment-modal.component.css
// module id = ./src/app/shared/components/choosepayment-modal/choosepayment-modal.component.css
// module chunks = main